"use client";

import Icon from "@/components/library/Icon";

interface StepErrorStateProps {
  /** The error message to display. */
  readonly message: string;
  /** Called when the user clicks the retry button. */
  readonly onRetry: () => void;
  /** Label for the retry button. */
  readonly retryLabel: string;
}

export function StepErrorState({ message, onRetry, retryLabel }: StepErrorStateProps) {
  return (
    <div className="rounded-2xl border border-destructive/60 bg-destructive/10 p-4 text-sm text-destructive space-y-2">
      <p>{message}</p>
      <button
        type="button"
        onClick={onRetry}
        className="inline-flex items-center gap-1.5 text-sm font-medium text-destructive hover:underline"
      >
        <Icon icon="arrow-rotate-left" className="w-3.5 h-3.5" />
        {retryLabel}
      </button>
    </div>
  );
}
